const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/item-drop-cards', {
  title: 'Item Dropdown cards',
  description: 'Exiba informações rápidas e diretas',
  icon: 'admin-site',
  category: 'layout',
  attributes,
  supports: {
    align: ['full'],
  },
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
